module.exports = __webpack_public_path__ + "static/media/cmarket.e96cf78b.png";